// @flow

/**
 * Module dependencies.
 */

import { Link } from 'react-router-dom';
import { colors, defaultTransition, states, units } from 'client/styles';
import styled from 'styled-components';

/**
 * `LinkIcon` component.
 */

export const LinkIcon = styled(Link)`
  color: ${({ color }): string => color};
  display: inline-block;
  transition: color ${defaultTransition};

  span {
    color: ${colors.brandPrimary};
    float: left;
    margin: 0 ${units(1)};
  }

  ${states.action`
    text-decoration: none;
  `};

  ${states.interaction`
    color: ${colors.brandPrimary};
  `};
`;

/**
 * Link icon secondary.
 */

export const LinkIconSecondary = styled(Link)`
  color: ${colors.brandPrimary};
  display: inline-block;
  transition: color ${defaultTransition};

  span {
    float: right;
    margin: 0 ${units(1)};
  }

  ${states.action`
    text-decoration: none;
  `};

  ${states.interaction`
    color: ${colors.brandSecondary};
  `};
`;

/**
 * `LinkDefault` component.
 */

export const LinkDefault = styled(Link)`
  color: ${({ color }): string => color};
  display: inline-block;
  transition: color ${defaultTransition};

  ${states.action`
    text-decoration: none;
  `};

  ${states.interaction`
    color: ${colors.brandPrimary};
  `};
`;



// WEBPACK FOOTER //
// ../src/client/components/core/buttons/links.js